import { HTMLReactParserOptions } from 'html-react-parser';
import Latex from 'react-latex-next';
import { useMemo } from 'react';
import 'katex/dist/katex.min.css';
import {
  hasLatexExpression,
  shouldSkipLatexParentTag,
} from '../../../../utils/latex';
import { parseHtmlWithMathLatex } from '../../../../utils/htmlParser';

interface LatexHTMLParserProps {
  html: string;
}

const LatexHTMLParser = ({ html }: LatexHTMLParserProps) => {
  const parsedContent = useMemo(() => {
    const parserOptions: HTMLReactParserOptions = {
      replace: (domNode) => {
        if (domNode.type !== 'text') {
          return undefined;
        }

        const text = domNode.data;
        if (!text || !hasLatexExpression(text)) {
          return undefined;
        }

        if (
          domNode.parent?.type === 'tag' &&
          shouldSkipLatexParentTag(domNode.parent.name)
        ) {
          return undefined;
        }

        return <Latex>{text}</Latex>;
      },
    };

    return parseHtmlWithMathLatex(html, parserOptions);
  }, [html]);

  return <>{parsedContent}</>;
};

export default LatexHTMLParser;
